<template>
    <div class="section-text" :class="{
        'section-banner--row': styled === 'yes',
        'section-banner--column': styled !== 'yes',
    }" :style="`--bg: ${background}`">
    
        <div class="section-text__content has-overflow">
            <h2 class="title title--dash" v-if="title">{{ title }}</h2>
            <div class="section__text" v-html="text" />

            <SectionButton
                v-if="button"
                :button="button"
            />
        </div>
        
    </div>
</template>

<script>
import { textProps, optionsProps } from './sectionProps'
import SectionButton from './SectionButton.vue'

export default {
    props: {
        styled: String,
        button: {
            type: [Object, Boolean],
        },
        ...textProps,
        ...optionsProps,
    },

    components: {
        SectionButton,
    },
}
</script>

<style lang="scss" scoped>
.section-text {
    background-color: var(--bg);
    padding: 3rem 20px;
}

@media (width > 767px) {
    .section-text {
        padding: 4rem;
    }
}

</style>